import type { Component } from 'vue'
import { defineAsyncComponent } from 'vue'

import { provideNotificationItemActions } from '@common/notification-layer/composables/useNotificationItemActions'
import { isEventConnectionRequestNotification } from '@clientportal/cp-events-layer/utils/event-connections.utils'

import type { INotification } from '@common/notification-layer/types/notification.types'

const EventConnectionNotificationActions = defineAsyncComponent(
  () => import('@clientportal/cp-events-layer/components/molecules/EventConnectionNotificationActions.vue')
)

/**
 * First match wins. Add a domain predicate and its action component here when a new
 * notification type needs row actions. The common list only injects the resolver.
 */
const notificationActionSources: Array<{
  matches: (notification: INotification) => boolean
  component: Component
}> = [
  {
    matches: isEventConnectionRequestNotification,
    component: EventConnectionNotificationActions,
  },
]

export function useNotificationItemActionRegistry() {
  provideNotificationItemActions(notification => notificationActionSources.find(source => source.matches(notification))?.component)
}
